import { render, staticRenderFns } from "./DateRangePicker.vue?vue&type=template&id=83c10036&scoped=true"
import script from "./DateRangePicker.vue?vue&type=script&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&lang=js"
import style0 from "./DateRangePicker.vue?vue&type=style&index=0&id=83c10036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c10036",
  null
  
)

export default component.exports